<script setup lang="ts">
const { t } = useI18n()
const schoolSelector = useSchoolSelector()

const open = ref(false)
const triggerText = computed(() => open.value ? 'Lukk' : t('settings.changeSchool'))
</script>

<template>
  <ModusCollapsibleRoot
    v-if="schoolSelector.organizations.length > 1"
    v-model:open="open"
  >
    <ModusCollapsibleTrigger class="trigger">
      <span>
        {{ triggerText }}
      </span>
    </ModusCollapsibleTrigger>
    <ModusCollapsibleContent>
      <div class="select-school-container">
        <CommonTypography
          variant="h4"
          component="h2"
          style="margin: 0;"
        >
          {{ $t('schoolSelector.chooseActive') }}
        </CommonTypography>
        <SchoolSelectorRadioGroup
          :aria-label="$t('schoolSelector.chooseActive')"
          @update:model-value="schoolSelector.updateActive"
        />
      </div>
    </ModusCollapsibleContent>
  </ModusCollapsibleRoot>
</template>

<style lang="scss" scoped>
  .trigger, .trigger .icon {
    color: var(--color-yellow-10)
  }

  .trigger span {
    border-bottom: 1px solid var(--color-yellow-10);
  }

  .trigger {
    @include body;

    background-color: transparent;
    font-weight: 500;
    padding: 0;
    margin-left: 34px;

    &:hover {
      span {
        border-color: transparent;
      }
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px var(--color-yellow-10);
    }
  }

  .select-school-container {
    padding: 24px;
    background-color: var(--color-yellow-10);
    color: var(--color-blue-50);
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 40px;
  }
</style>
